function startQuizCountdown(timer, countdownEl)
{
    var existingId = timer._quizTimerIntervalId;
    var durationMs = 900000;
    var storageKey = "quiz_offer_timer_start";

    if (existingId)
    {
        clearInterval(existingId);
    }

    var startTime = 0;

    try
    {
        startTime = parseInt(localStorage.getItem(storageKey), 10) || 0;
    }
    catch (e) {}

    if (!startTime)
    {
        startTime = Date.now();

        try
        {
            localStorage.setItem(storageKey, String(startTime));
        }
        catch (e) {}
    }

    var remaining = durationMs - (Date.now() - startTime);

    if (remaining <= 0)
    {
        remaining = 0;
    }

    updateTimerDisplay(countdownEl, remaining);

    timer._quizTimerIntervalId = setInterval(function tickTimer()
    {
        var elapsed   = Date.now() - startTime;
        var remaining = durationMs - elapsed;

        if (remaining <= 0)
        {
            remaining = 0;
            clearInterval(timer._quizTimerIntervalId);
        }

        updateTimerDisplay(countdownEl, remaining);
    }, 1000);
}

function initQuizOfferTimerPopup()
{
    var timer = document.querySelector(".quiz-offer-timer");

    if (!timer) return;

    var infoBtn = timer.querySelector(".quiz-offer-timer-info");

    if (infoBtn)
    {
        infoBtn.addEventListener("click", function onInfoClick(e)
        {
            e.stopPropagation();
            timer.classList.toggle("is-open");
        });
    }

    document.addEventListener("click", function onDocumentClick(e)
    {
        if (timer.classList.contains("is-open") && !timer.contains(e.target))
        {
            timer.classList.remove("is-open");
        }
    });
}

function initQuizOfferTimer()
{
    var timer = document.querySelector(".quiz-offer-timer");

    if (timer && !timer.classList.contains("hidden"))
    {
        var countdownEl = timer.querySelector(".quiz-offer-timer-countdown");

        if (countdownEl)
        {
            startQuizCountdown(timer, countdownEl);
        }
    }

    initQuizOfferTimerPopup();
}

function updateTimerDisplay(el, remainingMs)
{
    var totalSeconds = Math.ceil(remainingMs / 1000);
    var minutes      = Math.floor(totalSeconds / 60);
    var seconds      = totalSeconds % 60;
    var display      = String(minutes) + ":" + (seconds < 10 ? "0" : "") + String(seconds);

    el.textContent = display;
}

function startQuizOfferTimer()
{
    var activeKey = "quiz_offer_timer_active";
    var storageKey = "quiz_offer_timer_start";

    try
    {
        localStorage.setItem(activeKey, "1");
        localStorage.setItem(storageKey, String(Date.now()));
    }
    catch (e) {}

    var timer = document.querySelector(".quiz-offer-timer");

    if (timer)
    {
        var countdownEl = timer.querySelector(".quiz-offer-timer-countdown");

        timer.classList.remove("hidden");

        if (countdownEl)
        {
            startQuizCountdown(timer, countdownEl);
        }
    }
}

function stopQuizOfferTimer()
{
    var timer = document.querySelector(".quiz-offer-timer");
    var activeKey = "quiz_offer_timer_active";
    var storageKey = "quiz_offer_timer_start";

    if (timer && timer._quizTimerIntervalId)
    {
        clearInterval(timer._quizTimerIntervalId);
        timer._quizTimerIntervalId = null;
    }

    try
    {
        localStorage.removeItem(activeKey);
        localStorage.removeItem(storageKey);
    }
    catch (e) {}

    if (timer)
    {
        timer.classList.add("hidden");
    }
}

document.addEventListener("DOMContentLoaded", initQuizOfferTimer);
